var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading-gif"},[_c('div',{staticClass:"loader"},[_c('div',{staticClass:"loader-inner ball-beat"},[_c('div',{style:(_vm.style)}),_vm._v(" "),_c('div',{style:(_vm.style)}),_vm._v(" "),_c('div',{style:(_vm.style)})])])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-92af313c","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/basic/LoadingDot.vue
// module id = null
// module chunks = 